<template>
  <v-container>

    <v-dialog v-model="show_detail" max-width="500" persistent>
      <calldetail :item="detail_item" v-on:closeDialog="show_detail = false"></calldetail>
    </v-dialog>

    <v-layout justify-center>
      <v-flex fluid>

        <v-card>

          <v-toolbar card class="secondary">
            <v-icon>speaker_notes</v-icon>
            <v-spacer></v-spacer>
            <v-btn fab small flat @click="show_filter = !show_filter">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <!-- <v-btn fab small flat>
              <v-icon>save_alt</v-icon>
            </v-btn> -->
          </v-toolbar>

          <v-alert :value="load_error" type="error" outline class="ma-3">{{ load_error }}</v-alert>

          <v-container v-show="show_filter" transition="expand-y-transition">
            <cdrfilter @apply_filter="applyFilter"></cdrfilter>
          </v-container>

          <v-data-table :headers="headers" :items="items" item-key="recnum" :loading="loading" :pagination.sync="pagination" :rows-per-page-items="[10,20,50]" hide-actions>
            <template slot="items" slot-scope="props">
              <tr @click="selectItem(props.item)" style="cursor: pointer">
                <td>{{ props.item.timestamp }}</td>
                <td>{{ props.item.uniqueid }}</td>
                <td class="text-xs-center"><v-icon>{{ callTypeIcon(props.item.calltype) }}</v-icon></td>
                <td>{{ props.item.source }}</td>
                <td>{{ props.item.destination }}</td>
                <!--
                <td class="text-xs-left">
                  <div v-if="hasVoicelog(props.item.calltype)">
                    <v-icon class="mr-1">play_circle_outline</v-icon>
                    <v-icon class="ml-1">save_alt</v-icon>
                  </div>
                </td>
                -->
                <td class="text-xs-right">{{ props.item.billsec }}</td>
                <td class="text-xs-right">{{ props.item.cost ? props.item.cost.toFixed(2) : '' }}</td>
              </tr>
            </template>
          </v-data-table>

          <v-divider></v-divider>

          <v-card-actions>
            <v-layout row align-center>
              <v-flex class="text-xs-center">
                <v-pagination v-model="pagination.page" :length="pages" color="secondary darken-3" ></v-pagination>
              </v-flex>
            </v-layout>
          </v-card-actions>

        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import callDetail from './calldetail'
import cdrFilter from './cdrfilter'

export default {
  name: 'callrecords',
  components: {
    calldetail: callDetail,
    cdrfilter: cdrFilter
  },
  data: () => ({
    loading: false,
    pagination: {
      descending: true
    },
    headers: [
      // { text: 'ID', value: 'uniqueid' },
      { text: 'Timestamp', value: 'timestamp' },
      { text: 'ID', value: 'uniqueid' },
      { text: 'Type', value: 'tollcat', align: 'center', sortable: false },
      { text: 'From', value: 'src' },
      { text: 'To', value: 'dst' },
      // { text: 'Actions', sortable: false, align: 'left' },
      { text: 'Duration', value: 'billsec', align: 'right' },
      { text: 'Cost', value: 'cost', align: 'right' }
    ],
    items: [],
    load_error: '',
    show_detail: false,
    detail_item: {},
    show_filter: false,
    filter: {
      /* show_incoming: true,
      show_incoming_missed: true,
      show_outgoing: true,
      show_outgoing_missed: true */
    }
  }),
  methods: {
    populateTable: function () {
      this.loading = true
      this.load_error = ''
      this.items = []
      var url = '/cdrget'
      if (this.$store.getters.auth_user === 'admin') {
        if (!this.$store.state.admin_selacc) {
          url = '/cdrget/_'
        } else {
          url = '/cdrget/' + this.$store.state.admin_selacc
        }
      }

      var req_filter = {}
      if ('calltypes' in this.filter) {
        req_filter.type = {}
      }
      if ('start_date' in this.filter) { req_filter.start_date = this.filter.start_date }
      if ('end_date' in this.filter) { req_filter.end_date = this.filter.end_date }
      var tlistAppend = function(rf, new_item) {
        if (! 'type' in rf) {
          rf['type'] = ''
        }
        if (rf.type.length) { rf.type = rf.type + ',' }
        rf.type = rf.type + new_item
      }
      /*
      if ('show_incoming' in this.filter && this.filter.show_incoming) { tlistAppend(req_filter,'incoming') }
      if ('show_incoming_missed' in this.filter && this.filter.show_incoming_missed) { tlistAppend(req_filter,'missed_incoming') }
      if ('show_outgoing' in this.filter && this.filter.show_outgoing) { tlistAppend(req_filter,'outgoing') }
      if ('show_outgoing_missed' in this.filter && this.filter.show_outgoing_missed) { tlistAppend(req_filter,'missed_outgoing') }
      */
      if ('calltypes' in this.filter) {
        req_filter.type = this.filter.calltypes
        this.filter.calltypes.forEach(function(ct) {
          tlistAppend(req_filter,ct)
        })
      }

      if (!('start_date' in req_filter) && !('end_date' in req_filter)) {
        let dt = new Date()
        req_filter.end_date = dt.toISOString().substr(0,10)
        dt.setDate(dt.getDate() - 1)
        req_filter.start_date = dt.toISOString().substr(0,10)
      }

      this.$api.get(url,{ params: req_filter }).then(response => {
        this.items = response.data.data.slice()
        this.pagination.totalItems = this.items.length
        this.loading = false
      }).catch(e => {
        this.loading = false
        if (!e.response) {
          this.load_error = 'No response from API server'
        } else {
          this.load_error = 'Error loading table data (error ' + e.response.status + ')'
        }
      })
    },
    callTypeIcon: function (calltype) {
      if (calltype === 'incoming') { return 'call_received' }
      if (calltype === 'missed-incoming') { return 'call_missed' }
      if (calltype === 'outgoing') { return 'call_made' }
      if (calltype === 'missed-outgoing') { return 'call_missed_outgoing' }

      return 'call'
    },
    hasVoicelog: function (calltype) {
      if (calltype == 'incoming' || calltype == 'outgoing') {
        return true
      }
      return false
    },
    selectItem: function (item) {
      this.detail_item = Object.assign({},item)
      this.show_detail = true
    },
    applyFilter: function (filter) {
      this.filter = Object.assign({},filter)
      this.show_filter = false
    }
  },
  computed: {
    pages: function() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
        return 0
      }
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    acc_code: function() {
      if (this.$store.getters.auth_user === 'admin') {
        return this.$store.state.admin_selacc
      } else {
        return this.$store.getters.auth_user
      }
    }
  },
  watch: {
    acc_code: function () {
      this.populateTable()
    },
    filter: function () {
      this.populateTable()
    }
  },
  beforeMount: function () {
    this.populateTable()
  }
}
</script>

<style scoped>
</style>
